import { WaterfallAdjustmentsModal } from "features/waterfall/review/WaterfallAdjustmentsModal";
import { WaterfallReviewPageContext } from "features/waterfall/review/WaterfallReviewPage";
import { WaterfallReviewTableBoxTabs } from "features/waterfall/review/WaterfallReviewTableBoxTabs";
import { useWaterfallBreakdownRetrieveSuspense } from "gen/endpoints/fund-family-event/fund-family-event";
import { useWaterfallInvestmentClassificationSummaryTableDataRetrieveSuspense } from "gen/endpoints/fund-family-sub-event/fund-family-sub-event";
import React, { useCallback } from "react";
import { useNavigate, useOutletContext } from "react-router";
import { PageTabBody } from "shared/components/layout/PageTabBody";
import { TableBox } from "shared/components/table/box/TableBox";
import { TableBoxBody } from "shared/components/table/box/TableBoxBody";
import { TableBoxHeader } from "shared/components/table/box/TableBoxHeader";
import { DataTable } from "shared/components/table/data/DataTable";
import { useRequiredStringParams } from "shared/hooks/useRequiredStringParams";
import { rootRoute } from "shared/navigation/Routes";

export const WaterfallReviewInvestmentClassificationsPage: React.FC = () => {
  const {
    fundFamilyId,
    fundFamilySubEventId,
    fundFamilyEventId,
    fundEntityId,
  } = useRequiredStringParams();

  const { data: tableData } =
    useWaterfallInvestmentClassificationSummaryTableDataRetrieveSuspense(
      fundFamilyId,
      fundFamilySubEventId,
      fundEntityId,
    );

  const { isEqualizedView, waterfallAdjustmentState } =
    useOutletContext<WaterfallReviewPageContext>();

  const [adjustmentModalIsOpen, setAdjustmentModalIsOpen] =
    waterfallAdjustmentState;

  const navigate = useNavigate();

  const fundLevelPath = rootRoute({})
    .fundFamilies({})
    .fundFamily({ fundFamilyId })
    .capitalActivity({})
    .capitalActivityEvent({ fundFamilyEventId })
    .waterfall({})
    .review({
      fundFamilySubEventId,
      fundEntityId,
    }).$;

  const navigateToFundLevel = useCallback(
    () => navigate(fundLevelPath),
    [fundLevelPath, navigate],
  );

  const { data: breakdownTableData } = useWaterfallBreakdownRetrieveSuspense(
    fundFamilyId,
    fundFamilyEventId,
    fundFamilySubEventId,
    fundEntityId,
    {
      is_equalized_view: isEqualizedView || undefined,
    },
  );

  return (
    <PageTabBody isFullHeight={true}>
      <TableBox isFullWidth={true}>
        <TableBoxHeader>
          <WaterfallReviewTableBoxTabs />
        </TableBoxHeader>
        <TableBoxBody>
          <DataTable data={tableData} />
        </TableBoxBody>
      </TableBox>
      {adjustmentModalIsOpen && (
        <WaterfallAdjustmentsModal
          distributionData={breakdownTableData}
          isOpen={adjustmentModalIsOpen}
          onSuccess={() => {
            setAdjustmentModalIsOpen(false);
            navigateToFundLevel();
          }}
          onCloseComplete={() => {
            setAdjustmentModalIsOpen(false);
          }}
        />
      )}
    </PageTabBody>
  );
};
